"use client";
import React from "react";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import CourseCard from "@/components/common/card/CourseCard";
import { Empty } from "antd";

export default function CourseInfo({ instructor }) {
  console.log("instructor courseinfo", instructor);
  return (
    <div className="course-slider">
      <div className="courses">
        {instructor?.courses.length > 0 ? (
          <Swiper
            modules={[Navigation, Autoplay]}
            slidesPerView={1}
            spaceBetween={20}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            loop={true}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            breakpoints={{
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
          >
            {instructor?.courses?.map((courseinfo, index) => (
              <SwiperSlide key={index}>
                <CourseCard course={courseinfo.course} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <Empty description="কোনো কোর্স পাওয়া যায়নি" />
        )}
      </div>

      {/* arrows */}
      {instructor?.courses.length > 0 && (
        <div className="course_arrow">
          <div className="swiper-button-prev">
            <button className="arrow-icon">
              <IoChevronBackOutline />
            </button>
          </div>
          <div className="swiper-button-next">
            <button className="arrow-icon">
              <IoChevronForwardOutline />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
